import { Button, Stack, Typography } from "@mui/material";
import { TemplateData } from "../../types"
import { useNavigate } from "react-router-dom";
import { CheckIcon } from "../../assets/svgs/CheckIcon";
import { ClockIcon } from "../../assets/svgs/ClockIcon";
import { WarningIcon } from "../../assets/svgs/WarningIcon";
import { GlobeIcon } from "../../assets/svgs/GlobeIcon";
import INoImage from "../../assets/images/no-image.jpg"

interface TemplateThumbnailProps {
  template: TemplateData;
}

export const TemplateThumbnail = ({template}: TemplateThumbnailProps) => {
  const navigate = useNavigate();

  const onEdit = () => {
    navigate(`/templates/${template.id}`);
  }

  const onClone = (e: any) => {
    e.preventDefault();
    navigate(`/templates/${template.id}/clone`);
  }

  const onSchedule = (e: any) => {
    e.preventDefault();
    navigate(`/templates/${template.id}/schedule`);
  }

  const onDesign = (e: any) => {
    if (e.target.tagName == 'BUTTON') return;
    e.preventDefault();
    navigate(`/templates/${template.id}/design`);
  }

  return (
    <Stack className="template-thumbnail">
      <Stack
        borderRadius={2}
        alignItems='center'
        justifyContent='center'
        spacing={1}
        overflow="hidden"
        onClick={onDesign}
        sx={{
          border: `1px solid ${template.status ? '#909894' : '#EA7200'}`, 
          height: { xs: '170px', xl: '200px' },
          width: '100%',
          cursor: 'pointer', 
          position: 'relative',
          '&:hover': {
            "& .hover-overlay": {
              borderTop: `1px solid ${template.status ? '#909894' : '#EA7200'}`,
              height: '32px',
              transition: 'all .3s',
            }
          }
        }}
      >
        <Stack direction='row' spacing={1/2} sx={{ position: 'absolute', top: '10px', left: '10px' }}>
          {template.status && <CheckIcon />}
          {!template.status && <ClockIcon />}
          {/* {template.status === 'inactive' && <WarningIcon />}
          {template.status === 'targeting1' && <GlobeIcon />}
          {template.status === 'targeting2' && <><ClockIcon /><GlobeIcon /></>} */}
        </Stack>
        <Stack className="feature-image" height="100%" justifyContent="center" direction="row" spacing={0} mt={0}>
          {
            template.preview_image ? (
              <img
                src={template.preview_image}
                alt={template.name}
                width="100%"
                height="96%"
                loading="lazy"
              />
            ) : (
              <img
                src={INoImage}
                alt='No Content'
                width="80%"
                height="96%"
                loading="lazy"
              />
            )
          }
        </Stack>
        <Stack 
          className="hover-overlay"
          direction="row"
          height="0px"
          overflow="hidden"
          sx={{ 
            position: "absolute",
            width: "100%",
            bottom: "0px",
            background: "#F4F4F4",
            transition: 'all .3s',
          }}
        >
          <Stack
            width="100%"
            justifyContent="center"
            alignItems="center"
            spacing={0}
            borderRight={`1px solid ${template.status ? '#909894' : '#EA7200'}`}
          >
            <Button
              variant="text"
              color={template.status ? 'inherit' : 'warning' }
              sx={{ fontWeight: "300", width: "100%" }}
              onClick={onSchedule}
            >
              Schedule
            </Button>
          </Stack>
          <Stack
            width="100%"
            justifyContent="center"
            alignItems="center"
            spacing={0}
            borderRight={`1px solid ${template.status ? '#909894' : '#EA7200'}`}
          >
            <Button
              variant="text"
              color={template.status ? 'inherit' : 'warning' }
              sx={{ fontWeight: "300", width: "100%" }}
              onClick={onClone}
            >
              Clone
            </Button>
          </Stack>
          <Stack
            width="100%"
            justifyContent="center"
            alignItems="center"
            spacing={0}
          >
            <Button
              variant="text"
              color={template.status ? 'inherit' : 'warning' }
              sx={{ fontWeight: "300", width: "100%" }}
              onClick={onEdit}
            >
              Edit
            </Button>
          </Stack>
        </Stack>
      </Stack>
      <Typography 
        color={template.status ? '#040505' : '#EA7200'}
        fontStyle={template.status ? 'initial' : 'italic'}
      >
        {template.name}
      </Typography>
    </Stack>
  )
}